import { localStorageService, StorageKeys } from './storageService';
export function getLocalCalendarDayString() {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
export function readTermsAcceptanceDailyCache() {
    try {
        return localStorageService.getItemSync(StorageKeys.TermsAcceptanceDailyCache);
    }
    catch {
        return null;
    }
}
export function writeTermsAcceptanceDailyCache(payload) {
    try {
        localStorageService.setItemSync(StorageKeys.TermsAcceptanceDailyCache, payload);
    }
    catch {
    }
}
